import * as actionTypes from "../actions/actionType";

const initialState = {
  userdata: [],
};

export const healthKitReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_HEALTHKIT_DATA:
      return {
        ...state,
        userdata: action.payload,
      };

    default:
      return state;
  }
};
